import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Typography, Space } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { TextArea } = Input;

const StepGeneral = ({ formData, onNext, onSubmit }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (formData) {
      form.setFieldsValue({
        title: formData.title || formData.name || '',
        description: formData.description || '',
      });
    }
  }, [formData, form]);

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      await onSubmit(1, {
        title: values.title,
        description: values.description,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Title level={4}>Document Information</Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
        Enter the basic information for this document.
      </Text>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          title: formData?.title || formData?.name || '',
          description: formData?.description || '',
        }}
      >
        <Form.Item
          name="title"
          label="Document Title"
          rules={[{ required: true, message: 'Please enter a document title' }]}
        >
          <Input placeholder="Enter document title" size="large" />
        </Form.Item>

        <Form.Item
          name="description"
          label="Description (Optional)"
        >
          <TextArea
            rows={4}
            placeholder="Enter a description for this document"
          />
        </Form.Item>

        <Form.Item style={{ marginTop: 32 }}>
          <Space>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              icon={<ArrowRightOutlined />}
              size="large"
            >
              Next: Add Signers
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
};

export default StepGeneral;
